import styled from 'styled-components';

export const CancelBreakOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
        border: solid 1px ${props.theme.colors.grey.lighte7}; 
    `
);


export const BreakUpInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
        flex-direction: column;
    `
);

export const BreakUpInfoTextWrap = styled.div(
    props => `
        width:70%;
        display: flex;
        flex-direction: column;
        border-right: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    `
);

export const BreakUpMainText = styled.p(
    props => `
        font-size: ${props.fontSize ? `${props.fontSize}px` : props.theme.font.large.font14};
        color: ${props.fontColor ? props.fontColor : props.theme.colors.black.base};
        font-weight: ${props.fontWeight ? props.fontWeight : ''};
    `
);

export const BreakUpInfoSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        padding-top: ${props.theme.spacing.base};
    `
);

export const BreakUpPriceWrap = styled.div(
    props => `
        width:30%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    `
);

export const BreakUpSubPriceText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-top: ${props.theme.spacing.base};
    `
);

export const BreakupRow = styled.div(
  props => `
    display: flex;
  `
);
